import { createSelector } from 'reselect';

const getModal = state => state.modal;

const ModalSelectors = {
    makeAddPropertyModal: createSelector([getModal], modal => modal.modalAddProperty),
    makeImageCarouselModal: createSelector([getModal], modal => modal.modalImageCarousel),
    makeModal: getModal,
};

export default ModalSelectors;
